import { Icon, IconProps } from "../";

export const TriangleRightLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 12L8 6.80385V17.1962L17 12ZM19.5 12.866C20.1667 12.4811 20.1667 11.5189 19.5 11.134L7.5 4.20578C6.83333 3.82088 6 4.302 6 5.0718V18.9282C6 19.698 6.83333 20.1791 7.5 19.7942L19.5 12.866Z"
      />
    </Icon>
  );
};
